// extracted by mini-css-extract-plugin
export default {"overlay":"CustomSpinner_overlay__xe7uj"};